import { useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { LogOut, Loader2 } from "lucide-react";
import clienteApi, { CLI_TOKEN_KEY } from "../../lib/clienteApi";
import { ClienteBrand } from "./ClienteLogin";
import { ClientePraticaView } from "./ClientePraticaView";
import { ClienteStudioHeader } from "./ClienteStudioHeader";
import { ClienteNewMessagePopup } from "./ClienteNewMessagePopup";
import { ClientePushToggle } from "./ClientePushToggle";
import PrivacyGate from "../../components/PrivacyGate";
import CookieBanner from "../../components/CookieBanner";

export default function ClientePortal() {
  const nav = useNavigate();
  const token = localStorage.getItem(CLI_TOKEN_KEY);
  const [me, setMe] = useState(null);
  const [pratiche, setPratiche] = useState(null);
  const [activeId, setActiveId] = useState("");
  const [focus, setFocus] = useState(0);
  const openMessages = (pid) => { setActiveId(pid); setFocus((n) => n + 1); };

  useEffect(() => {
    if (!token) return;
    clienteApi.get("/auth/me").then(({ data }) => {
      if (data.role !== "cliente") { localStorage.removeItem(CLI_TOKEN_KEY); nav("/cliente/login", { replace: true }); return; }
      setMe(data);
    }).catch(() => {});
    clienteApi.get("/cliente/pratiche").then(({ data }) => { setPratiche(data); if (data.length) setActiveId(data[0].id); }).catch(() => setPratiche([]));
  }, [token, nav]);

  if (!token) return <Navigate to="/cliente/login" replace />;
  const logout = () => { localStorage.removeItem(CLI_TOKEN_KEY); nav("/cliente/login", { replace: true }); };
  const active = (pratiche || []).find((p) => p.id === activeId);

  return (
    <div className="min-h-screen pgp-grid-bg" data-testid="cliente-portal">
      <PrivacyGate client={clienteApi} onLogout={logout} light />
      <CookieBanner />
      <header className="sticky top-0 z-20 bg-white/95 backdrop-blur border-b border-slate-200">
        <div className="max-w-5xl mx-auto flex items-center justify-between gap-3 px-4 sm:px-5 h-14 sm:h-16">
          <ClienteBrand />
          <div className="flex items-center gap-1.5 sm:gap-3 shrink-0">
            <span className="hidden sm:block text-sm text-slate-600" data-testid="cliente-portal-user">{me?.name}</span>
            <ClientePushToggle />
            <button onClick={logout} data-testid="cliente-logout" className="flex items-center gap-1.5 text-sm text-slate-500 hover:text-red-500 transition-colors"><LogOut className="h-4 w-4" />Esci</button>
          </div>
        </div>
      </header>
      <ClienteNewMessagePopup userId={me?.id} onOpen={openMessages} />
      <main className="max-w-5xl mx-auto px-3 sm:px-5 py-4 sm:py-8 space-y-4 sm:space-y-6">
        <ClienteStudioHeader />
        {pratiche === null ? (
          <div className="flex justify-center py-16"><Loader2 className="h-6 w-6 animate-spin text-amber-500" /></div>
        ) : pratiche.length === 0 ? (
          <div className="pgp-card p-10 text-center text-sm text-slate-500" data-testid="cliente-no-pratiche">Non hai pratiche aperte al momento</div>
        ) : (
          <>
            {pratiche.length > 1 && (
              <div className="flex gap-2 overflow-x-auto pb-1 -mx-1 px-1" data-testid="cliente-pratiche-switch">
                {pratiche.map((p) => (
                  <button key={p.id} onClick={() => { setActiveId(p.id); setFocus(0); }} data-testid={`cliente-pratica-tab-${p.id}`}
                    className={`shrink-0 rounded-full px-4 py-1.5 text-sm font-mono border transition-colors ${p.id === activeId ? "bg-amber-500 border-amber-500 text-[#0a0d14]" : "border-slate-300 text-slate-600 hover:bg-slate-100"}`}>
                    {p.numero_pratica}
                  </button>
                ))}
              </div>
            )}
            {active && <ClientePraticaView key={`${active.id}-${focus}`} pratica={active} initialTab={focus ? "messaggi" : null} />}
          </>
        )}
      </main>
    </div>
  );
}
